// Shared site data for all the sub-pages (the homepage keeps its own copy untouched).
export const SITE = {
  name: "StaffAble AI",
  url: "https://staffableai.com",
  whatsapp: "919970813971",
  tagline: "Trained AI Employees for your business.",
};

export const SAFE = "Free call. No pressure. You decide.";

// header nav for sub-pages (cross-site routes)
export const NAV: { label: string; href: string }[] = [
  { label: "Use cases", href: "/use-cases" },
  { label: "AI Employees", href: "/ai-employees" },
  { label: "Services", href: "/services" },
  { label: "Industries", href: "/industries" },
  { label: "OPD AI", href: "/opd-ai/" },
  { label: "Demo", href: "/demo/" },
  { label: "About", href: "/about" },
];

// footer menu, our own internal routes
export const FOOTER_TAGLINE = "Trained AI Employees for your business.";
export const FOOTER_COLS: { title: string; links: [string, string][] }[] = [
  { title: "Use cases", links: [
    ["All use cases", "/use-cases"],
    ["AI Caller & WhatsApp Receptionist", "/use-cases/sales-ai-employee"],
    ["Lead Follow Up Employee", "/use-cases/lead-follow-up"],
    ["Social Media Employee", "/use-cases/marketing-ai-employee"],
    ["Operations Employee", "/use-cases/operations-ai-employee"],
  ] },
  { title: "Industries", links: [
    ["Real estate", "/industries/real-estate"],
    ["Clinics and hospitals", "/industries/clinics"],
    ["Hair and skin clinics", "/industries/hair-derm-clinics"],
    ["Salons and spas", "/industries/salons"],
    ["AI Employee vs chatbot", "/ai-employee-vs-chatbot-vs-automation"],
  ] },
  { title: "Company", links: [
    ["Services", "/services"],
    ["AI Employees", "/ai-employees"],
    ["Pricing", "/pricing/"],
    ["Watch a sample day", "/demo/"],
    ["About", "/about"],
    ["Contact", "/contact"],
    ["Book a free call", "/apply"],
  ] },
  { title: "Legal", links: [
    ["Privacy Policy", "/privacy"],
    ["Terms and Conditions", "/terms"],
    ["Refund and Cancellation", "/refund-cancellation"],
    ["Cookie Policy", "/cookie-policy"],
    ["Data Processing", "/data-processing"],
  ] },
];

export const SOCIAL: [string, string, string][] = [
  ["Instagram", "https://www.instagram.com/staffableai", "instagram"],
  ["LinkedIn", "https://www.linkedin.com/company/staffable-ai", "linkedin"],
  ["Facebook", "https://www.facebook.com/staffableai", "facebook"],
];

// Third-person scenario cards - no invented names, cities or portrait photos.
export const SCENARIOS: { role: string; text: string }[] = [
  { role: "Paediatric clinic", text: "Parents message while the doctor is with a child. The WhatsApp Receptionist shares the next free slots, books the visit and sends a reminder the evening before. Bookings and reminders only. It never gives medical advice." },
  { role: "Restaurant & nightclub", text: "The rush of messages lands after 8 pm, right when the floor is packed. Table questions and party enquiries get answered and booked while the manager is still on the floor." },
  { role: "Salon", text: "Bridal enquiries always open the same way: price, dates, photos. The first replies go out in about a minute and the owner gets a short list of the serious ones." },
  { role: "Dental clinic", text: "Patients forget cleanings unless somebody reminds them. Reminders and rebooking now run on their own, and the front desk finally has its hands free." },
  { role: "Wholesale distributor", text: "Retailers ask for stock and rates after closing time. They get the latest list without waiting for morning. The team checks the odd orders the next day." },
  { role: "Coaching centre", text: "Fees, batches, trial classes. Parents ask at all hours, first replies go out in about a minute, and the owner gets a short list to call back." },
];

// Back-compat alias so any straggler import keeps compiling (same shape minus name/img).
export const REVIEWS = SCENARIOS;
